<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-12 09:51:22
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-18 17:55:07
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\drInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex-row pl-12 pr-8" style="width: 190px">
		<yx-avatar class="flex-shrink" :size="40" :src="row.head" />
		<div class="ml-8">
			<div class="flex-row-align-center">
				<platform-icon :platformId="row.platform_id" class="flex-shrink"></platform-icon>
				<el-tooltip placement="top" effect="light" :content="anchorInfo" :disabled="row.tabName !== '1'">
					<span
						class="ml-4 yx-color-text-primary font-h6-medium line-ellipsis-1 cursor-pointer hover"
						style="max-width: 124px"
						@click="showdetailDrawer"
						>{{ row.anchor_id != 0 ? row.anchor_name : '无达人信息' }}</span
					>
				</el-tooltip>
			</div>
			<div class="flex-row-align-center font-h6-regular yx-color-text-secondary">
				<span class="flex-shrink">{{ row.platform_id | formatPlatformName('unify') }}：</span>
				<el-tooltip placement="top" v-ak-tooltip-auto-show :content="anchorAccount">
					<span class="line-ellipsis" style="max-width: 100px">{{ anchorAccount| formatEmpty }}</span>
				</el-tooltip>
				<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(anchorAccount)"></i>
			</div>
			<div class="font-h6-regular yx-color-text-secondary flex-row-align-center">
				<span>达人招商：</span>
				<el-tooltip placement="top" v-ak-tooltip-auto-show :content="row.nick_name">
					<span style="max-width: 80px" class="line-ellipsis">{{ row.nick_name | formatEmpty }}</span>
				</el-tooltip>
			</div>
			<div class="font-h6-regular yx-color-text-secondary flex-row-align-center" v-if="row.team_institution_id && row.team_institution_id != 0">
				<span>团长名称：</span>
				<el-tooltip placement="top" v-ak-tooltip-auto-show :content="row.institution_info.institution_name">
					<span style="max-width: 80px" class="line-ellipsis">{{ row.institution_info.institution_name | formatEmpty }}</span>
				</el-tooltip>
			</div>
			<div class="mt-2">
				<el-tooltip v-if="retailInfo.tag" :content="retailInfo.tooltip" placement="top">
					<plainTag :type="retailInfo.type">
						{{ retailInfo.tag }}
					</plainTag>
				</el-tooltip>
				<plainTag :type="sellGoodstype" v-if="row.sell_goods_type">
					{{ row.sell_goods_desc }}
				</plainTag>
			</div>
		</div>
	</div>
</template>
<script>
import { copy } from '@/utils/common';
import plainTag from '@/components/ui/plainTag';
import { PLATFORM_DY, PLATFORM_KS,PLATFORM_SP } from '@/utils/dataMap';
export default {
	components: {
		plainTag,
	},
	inject: {
		injectShowDetailDrawer: {
			default: () => {
				return () => {};
			},
		},
	},
	props: {
		row: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		retailInfo({ row }) {
			const { retail_type = '' } = row;
			const arr = [
				{ tag: '达人分销', tooltip: '直接与达人合作，由达人直接进行分销带货', type: 'danger' },
				{ tag: '团长分销', tooltip: '报名了二级团长活动，由二级团长找达人进行分销带货', type: 'primary' },
			];
			return arr[retail_type] || {};
		},
		sellGoodstype({ row }) {
			const { sell_goods_type = '' } = row;
			let obj = {
				0: 'primary',
				1: 'danger',
				2: 'primary',
			};
			return obj[sell_goods_type];
		},
		anchorInfo({ row }) {
			let obj = {
				[PLATFORM_DY.value]: `达人信息  粉丝量 ${row.fans_num} | 月橱销量 ${row.month_sale} | 月橱销售额 ${row.month_live_sale}`,
				[PLATFORM_KS.value]: `达人信息  粉丝量 ${row.fans_num} | 月订单量 ${row.month_sale} | 月销售额 ${row.month_live_sale}`,
				[PLATFORM_SP.value]: `达人信息  粉丝量 ${row.fans_num} | 月订单量 ${row.month_sale} | 月销售额 ${row.month_live_sale}`,
			};
			return obj[row.platform_id];
		},
		anchorAccount(){
			//获取k抖音号，快手号，视频id
			const temPF = {
				[dataMap.PLATFORM_DY.value]: this.row.anchor_account,
				[dataMap.PLATFORM_KS.value]: this.row.anchor_account,
				[dataMap.PLATFORM_SP.value]: this.row.anchor_uid,
			};
			return temPF[this.row.platform_id];
		},
	},
	data() {
		return {};
	},
	methods: {
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
		showdetailDrawer() {
			this.injectShowDetailDrawer(this.row);
		},
	},
};
</script>